import { MatDialogConfig } from '@angular/material/dialog';

export interface DialogData {
  title: string;
  message: string;
  primaryLabel: string;
  secondaryLabel?: string;
}

export enum DialogResult {
  Primary = 'primary',
  Secondary = 'secondary',
}

export const DIALOG_PANEL_CLASS = 'lib-dialog-panel';
export const DIALOG_TITLE_ID = 'lib-dialog-title';
export const DIALOG_MESSAGE_ID = 'lib-dialog-message';

// Spread into `MatDialog.open(DialogComponent, { ...DIALOG_DEFAULT_CONFIG, data })`.
export const DIALOG_DEFAULT_CONFIG: MatDialogConfig<DialogData> = {
  role: 'alertdialog',
  ariaLabelledBy: DIALOG_TITLE_ID,
  ariaDescribedBy: DIALOG_MESSAGE_ID,
  panelClass: DIALOG_PANEL_CLASS,
  maxWidth: 'calc(100vw - 32px)',
  width: '600px',
  autoFocus: 'first-tabbable',
  restoreFocus: true,
};
